export const authSwitchRoutes = {
  check: {
    password: '/check/password',
    f2a: {
      root: '/check/2fa',
      sms: '/check/2fa/sms',
      email: '/check/2fa/email',
      app: '/check/2fa/app'
    }
  },
  recover: {
    password: '/recover/password',
    error: '/recover/error',
    expired: '/recover/expired'
  },
  autologin: {
    base: '/auto/login',
    external: '/external/auto/login'
  },
  pwdlogin: '/login/onlyPassword'
};
export const getCheckPwdRoute = (username, buCode) => `${authSwitchRoutes.check.password}?username=${encodeURIComponent(username)}&buCode=${encodeURIComponent(buCode)}`;
export const getOnlyPwdRoute = (p, buCode) => `${authSwitchRoutes.pwdlogin}?p=${encodeURIComponent(p)}&bu=${encodeURIComponent(buCode)}`;